<template>
  <div>
    <loading-spinner />
    <div
      v-if="campaign.projectId && !loadingStatus"
      class="row"
    >
      <div class="col-sm-6">
        <Card
          icon="server"
          title="General"
        >
          <table>
            <tr>
              <td>Project ID</td>
              <td>
                <a
                  :href="previewProject"
                  target="_parent _blank"
                >{{ campaign.projectId }}</a>
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                <div class="float-left">
                  <div
                    v-if="campaign.statusCampaignTranslated !== 'Sent' && campaign.statusCampaignTranslated !== 'Rejected' && campaign.statusCampaignTranslated !== 'Draft'"
                    ref="statusDiv"
                    v-closable="{
                      exclude: ['statusDiv'],
                      handler: 'closeTooltip'
                    }"
                    class="custom-tooltip"
                    @click="onCustomOpen"
                  >
                    <ejs-tooltip
                      v-if="campaign.statusCampaignTranslated ==='Scheduled Active' || campaign.statusCampaignTranslated === 'Scheduled Inactive'"
                      ref="tooltip"
                      :content="statusToolTip"
                      css-class="customtip"
                      position="BottomCenter"
                      opens-on="Custom"
                    >
                      <span v-if="campaign.scheduleActive === 'Active'">
                        <font-awesome-icon
                          :icon="['fas', 'circle']"
                          size="xs"
                          class="success"
                          transform="shrink-3"
                        />
                        Scheduled Active
                        <font-awesome-icon
                          :icon="['far', 'chevron-down']"
                          size="xs"
                        /></span>
                      <span v-else-if="campaign.scheduleActive === 'Inactive'">
                        <font-awesome-icon
                          :icon="['fas', 'circle']"
                          size="xs"
                          class="danger"
                          transform="shrink-3"
                        />
                        Scheduled Inactive
                        <font-awesome-icon
                          :icon="['far', 'chevron-down']"
                          size="xs"
                        />
                      </span>
                    </ejs-tooltip>
                    <ejs-tooltip
                      v-if="campaign.statusCampaignTranslated === 'Approved'"
                      ref="tooltip"
                      :content="statusToolTip"
                      css-class="customtip"
                      position="BottomCenter"
                      opens-on="Custom"
                    >
                      <span>{{ campaign.statusCampaignTranslated }} <font-awesome-icon
                        :icon="['far', 'chevron-down']"
                        size="xs"
                      /></span>
                    </ejs-tooltip>
                    <ejs-tooltip
                      v-if="campaign.statusCampaignTranslated ==='Pending'"
                      ref="tooltip"
                      :content="statusToolTipPending"
                      css-class="customtip"
                      position="BottomCenter"
                      opens-on="Custom"
                    >
                      <span>Pending <font-awesome-icon
                        :icon="['far', 'chevron-down']"
                        size="xs"
                      /></span>
                    </ejs-tooltip>
                    <ejs-tooltip
                      v-if="campaign.statusCampaignTranslated ==='Testing'"
                      ref="tooltip"
                      :content="statusToolTipTesting"
                      css-class="customtip"
                      position="BottomCenter"
                      opens-on="Custom"
                    >
                      <span>Testing <font-awesome-icon
                        :icon="['far', 'chevron-down']"
                        size="xs"
                      /></span>
                    </ejs-tooltip>
                  </div>
                  <span v-if="campaign.statusCampaignTranslated === 'Sent' || campaign.statusCampaignTranslated === 'Rejected' || campaign.statusCampaignTranslated === 'Draft'">
                    {{ campaign.statusCampaignTranslated }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>Email Type</td>
              <td>
                <a
                  href="#"
                  @click="openEmailTypeSettings"
                >{{ campaign.emailTypeName }}</a>
              </td>
            </tr>
            <tr>
              <td>Campaign Name</td>
              <td>{{ campaign.title }}</td>
            </tr>
            <tr>
              <td>Subject</td>
              <td>{{ campaign.subject }}</td>
            </tr>
            <tr>
              <td>From Name</td>
              <td>{{ campaign.fromName }}</td>
            </tr>
            <tr>
              <td>From Email</td>
              <td>{{ campaign.fromEmail }}</td>
            </tr>
            <template v-if="campaign.replyName !== '#REPLYNAME#' && campaign.replyEmail !== '#REPLYTOEMAIL#'">
              <tr v-if="campaign.replyName">
                <td>Reply Name</td>
                <td>{{ campaign.replyName }}</td>
              </tr>
              <tr v-if="campaign.replyEmail">
                <td>Reply Email</td>
                <td>{{ campaign.replyEmail }}</td>
              </tr>
            </template>
            <tr v-if="dynamicContentUrl">
              <td>Dynamic Content</td>
              <td v-if="campaign.hasDynamicContent">
                <a
                  id="dynamicLink"
                  :href="dynamicContentUrl"
                  target="_blank"
                ><font-awesome-icon
                  :icon="['far', 'external-link-alt']"
                  size="sm"
                /> Launch Dynamic Content Module</a>
              </td>
              <td v-if="!campaign.hasDynamicContent">
                <font-awesome-icon
                  :icon="['far', 'external-link-alt']"
                  size="sm"
                /> Launch Dynamic Content Module
              </td>
            </tr>
          </table>
        </Card>
        <Card
          v-if="campaignJourney.settingValue === 'Y' && !isTransactional && !campaign.isSubProject"
          icon="project-diagram"
          title="Campaign Journey"
        >
          <div v-if="campaign.campaignJourneyName && campaign.canViewJourney">
            <table>
              <tr>
                <td>Campaign Type</td>
                <td>{{ campaign.isSubProject ? "Sub" : "Primary" }}</td>
              </tr>
              <tr>
                <td>Journey Name</td>
                <td>
                  <a
                    :href="viewProject"
                    target="_parent"
                  >{{ campaign.campaignJourneyName }}</a>
                </td>
              </tr>
              <tr>
                <td>Sub Campaigns</td>
                <td>{{ campaign.campaignJourneyInfo.length }}</td>
              </tr>
            </table>
            <br>
            <table
              v-if="campaign.campaignJourneyInfo.length"
              class="bordered"
            >
              <tr>
                <th>Campaign Name</th>
                <th>Project ID</th>
              </tr>
              <tr
                v-for="(item, index) in campaign.campaignJourneyInfo"
                :key="index"
              >
                <td>{{ item.projectName }}</td>
                <td>{{ item.projectId }}</td>
              </tr>
            </table>
          </div>
          <div
            v-if="!campaign.campaignJourneyName"
            class="text-center"
          >
            <div v-if="!noJourneyLaunchStatuses.includes(campaign.statusCampaignTranslated)">
              <span class="empty-state-icon">
                <font-awesome-icon :icon="['far', 'sitemap']" />
              </span>
              <h4>No Campaign Journey</h4>
              <p>Kick off a Campaign Journey to create a personalized experience for your recipients.</p>
              <p class="empty-state-button">
                <button
                  class="btn btn-lg btn-primary"
                  @click="openLaunchCampaignDialog"
                >
                  Launch
                </button>
              </p>
            </div>
            <div
              v-if="noJourneyLaunchStatuses.includes(campaign.statusCampaignTranslated)"
              class="noJourneyLaunch"
            >
              <div class="alert alert-info">
                <span>
                  <font-awesome-icon :icon="['far', 'info-circle']" /> Your journey can be kicked-off when the campaign is in Approved status.
                </span>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div class="col-sm-6">
        <Card
          v-if="!campaign.isSubProject"
          icon="users"
          title="Audience"
          router-link="View All"
          router-link-name="CampaignDetailsAudience"
          tab="summary"
        >
          <table>
            <tr>
              <td>Name</td>
              <td v-if="campaign.audienceName || newAudienceName">
                <router-link :to="{name: 'CampaignDetailsAudience', query: {clientId: $route.query.clientId, companyId: $route.query.companyId, campaignId: $route.query.campaignId, userEmail: $route.query.userEmail, tab: 'customer-details'}}">
                  <span v-if="campaign.audienceName">
                    {{ campaign.audienceName }}
                  </span>
                  <span v-if="newAudienceName">
                    {{ newAudienceName }}
                  </span>
                </router-link>
              </td>
              <td v-if="!campaign.audienceName">
                <div class="float-left">
                  <ejs-tooltip
                    v-if="!campaign.audienceId && !converted"
                    ref="newAudienceTooltip"
                    :content="newAudienceTemplate"
                    css-class="customtip"
                    position="BottomCenter"
                    opens-on="Click"
                  >
                    Not Set <br>
                    <span
                      ref="convertToAudienceRef"
                      class="link"
                    >Save Audience</span>
                  </ejs-tooltip>
                </div>
              </td>
            </tr>
            <tr>
              <td>Counts</td>
              <td v-show="audienceSummary.counts || audienceSummary.counts === null">
                Customer ({{ audienceSummary.counts === null ? '-' : audienceSummary.counts.CountTotal | numFormat }})
                Email ({{ audienceSummary.counts === null ? '-' : audienceSummary.counts.CountUnique | numFormat }})
              </td>
            </tr>
            <tr>
              <td>Privacy & Security</td>
              <td>
                <span v-if="campaign.includesCASL === true"><font-awesome-icon
                  :icon="['fas', 'circle']"
                  size="xs"
                  class="success"
                  transform="shrink-3"
                /> Included </span>
                <span v-if="campaign.includesCASL === false"><font-awesome-icon
                  :icon="['fas', 'circle']"
                  size="xs"
                  class="danger"
                  transform="shrink-3"
                /> Excluded </span>
                <span v-if="campaign.includesCASL === null"><font-awesome-icon
                  :icon="['fas', 'circle']"
                  size="xs"
                  class="fail"
                  transform="shrink-3"
                /> Not Set </span>
              </td>
            </tr>
          </table>
        </Card>
        <Card
          v-if="history.length"
          icon="clock"
          title="Key History"
          router-link="View all"
          router-link-name="CampaignDetailsHistory"
        >
          <History :items="history" />
        </Card>
      </div>
    </div>
    <div v-if="!campaign.projectId && !loadingStatus">
      <div class="alert alert-danger">
        <span>
          <font-awesome-icon :icon="['far', 'info-circle']" /> This campaign doesn't exist, please contact Product Help for assistance.
        </span>
      </div>
    </div>
    <ejs-dialog
      id="dialog"
      ref="dialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="dialogTemplate"
      :overlay-click="closeDialog"
      :visible="false"
      :animation-settings="animationSettings"
    />
    <ejs-dialog
      id="editScheduleDialogTemplate"
      ref="editScheduleDialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="editScheduleDialogTemplate"
      :overlay-click="overlayClick"
      :visible="false"
      :animation-settings="animationSettings"
    />
    <ejs-dialog
      id="launchCampaignDialogTemplate"
      ref="launchCampaignDialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="launchCampaignDialogTemplate"
      :overlay-click="overlayClick"
      :visible="false"
      :animation-settings="animationSettings"
    />
    <ejs-dialog
      id="rejectDialogTemplate"
      ref="rejectDialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="rejectDialogTemplate"
      :overlay-click="overlayClick"
      :visible="false"
      :animation-settings="animationSettings"
    />
    <ejs-toast
      ref="errorToastRef"
      title="Error"
      :content="errorMessage"
      :position="toastPosition"
      css-class="notification-error"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Card from '../components/Card'
import History from '../components/History'
import { mapState, mapGetters } from 'vuex'
import { phraseStyles } from '../mixins/phraseStyles'
import { iframeParentCommunication } from '../mixins/iframeParentCommunication'
import LoadingSpinner from '../components/LoadingSpinner'
import eInsightUrl from '../constants/eInsightUrl'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import { systemTimezone, isTimeZoneFeatureEnabled } from '../../src/constants/general'

Vue.use(VueMoment, {
  moment
})

const newAudienceTemplate = function (data) {
  return {
    template: Vue.component('NewAudienceTemplate', {
      data () {
        return {
          audienceName: '',
          hasError: false
        }
      },
      methods: {
        closeTooltipButton () {
          this.$parent.$parent.$parent.closeTooltipButton()
        },
        convertToAudience () {
          if (this.audienceName !== '' && this.audienceName.length < 255) {
            this.$parent.$parent.$parent.convertToAudience(this.audienceName)
          } else {
            this.hasError = true
          }
        }
      },
      template: `<div ref="newAudienceTemplate">
          <form id="new-audience-form">
            <div class="form-group">
              <label for="audienceName">Audience Name</label>
              <input type="text" class="form-control" id="audienceName" aria-describedby="" v-model="audienceName" v-bind:style="hasError ? 'border-color:#A82823;' : 'border-color:#ccc;'">
              <span v-if="audienceName.length > 255">Audience name exceeded 255 characters</span>
            </div>
            <div class="text-right">
              <button type="button" class="btn btn-lg btn-outline-secondary" @click='closeTooltipButton'>Cancel</button>
              <button type="button" class="btn btn-lg btn-primary ml-2" @click='convertToAudience'>Save</button>
            </div>
          </form>
        </div>`
    })
  }
}

const dialogTemplate = Vue.component('DialogTemplate', {
  data () {
    return {
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.manageCampaigns.campaign.summaryDetails
    }),
    activateSchedule () {
      return this.$store.getters.getEinsightUri + this.$parent.$parent.eInsightUrl.activateSchedule(this.$route.query.campaignId)
    },
    scheduleInTheFuture () {
      const now = moment().tz('America/New_York').format()
      const scheduleDate = this.campaign.scheduleDate + '-05:00'
      const inTheFuture = moment(scheduleDate).isSameOrAfter(now)
      return inTheFuture
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeDialog()
    },
    updateSchedule (activate) {
      this.$store.dispatch('activateschedule', { projectId: this.campaign.projectId, activate: activate, userEmail: atob(this.$route.query.userEmail) })
        .then(response => {
          this.$parent.$parent.closeDialog()
          this.$parent.$parent.refreshCampaigns()
        }, error => {
          console.log(error)
        })
    }
  },
  template: `
    <div v-if="campaign && campaign.scheduleActive">
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Confirm</h2></br>
        <p v-if="campaign.scheduleActive === 'Inactive'">Activating this schedule will resume sending.</p>
        <p v-if="campaign.scheduleActive === 'Active'">Deactivating this schedule will pause sending.</p></br>
        <button class="btn btn-lg btn-outline-secondary" @click="cancel">Cancel</button>
        <a :href="activateSchedule" class="btn btn-lg btn-success" v-if="campaign.scheduleActive === 'Inactive'&& !scheduleInTheFuture" target="_parent">Activate</a>
        <a href="javascript:void(0)" class="btn btn-lg btn-success" v-if="campaign.scheduleActive === 'Inactive' && scheduleInTheFuture" @click="updateSchedule(true)">Activate</a>
        <button @click="updateSchedule(false)" class="btn btn-lg btn-danger" v-if="campaign.scheduleActive === 'Active'">Deactivate</button>

      </div>
    </div>`
})

const statusToolTip = Vue.component('StatusToolTip', {
  data () {
    return {
      eInsightUrl: {},
      timezoneEnv: ''
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.manageCampaigns.campaign.summaryDetails,
      isPrimary: state => state.manageCampaigns.isPrimary
    }),
    schedule () {
      return this.$store.getters.getEinsightUri + eInsightUrl.editSchedule(this.$route.query.campaignId)
    },
    timezoneFallback () {
      return isTimeZoneFeatureEnabled() ? '' : `(${this.timezoneEnv})`
    }
  },
  mounted () {
    this.eInsightUrl = this.$parent.$parent.eInsightUrl
    this.timezoneEnv = systemTimezone()
  },
  methods: {
    editCampaign () {
      this.$parent.$parent.$parent.openEditScheduleDialog()
    },
    activateSchedule () {
      this.$parent.$parent.$parent.openDialog()
    },
    deactivateSchedule () {
      this.$parent.$parent.$parent.openDialog()
    }
  },
  template: `
    <div>
      <div v-if="campaign.status === 'Scheduled'">
        <p class="tooltip-title">Scheduled by {{campaign.scheduledBy}}</p>
        <p class="text-muted">{{campaign.scheduleModified | dateFormat}} ({{timezoneEnv}})</p>
        <p class="tooltip-title">Frequency</p>
        <p class="text-muted">{{campaign.scheduleFrequency}}</p>
        <p class="tooltip-title">Send on</p>
        <p class="text-muted">{{campaign.scheduleText}} {{timezoneFallback}}</p>
        <button @click="editCampaign" id="editSchedule" class="btn btn-lg btn-primary">Edit</button>
        <button v-if='campaign.scheduleActive === "Inactive"' class="tooltip-link btn btn-success btn-lg" @click="activateSchedule" id="activateSchedule">
            Activate
        </button>
        <button v-else-if='campaign.scheduleActive === "Active"' class="tooltip-link btn btn-danger btn-lg" @click="deactivateSchedule" id="cancelSchedule">
            Deactivate
        </button>
      </div>
      <div v-if="campaign.status === 'Approved'">
        <p class="tooltip-title">Approved by {{campaign.approvedBy}}</p>
        <p class="text-muted">{{campaign.approvedDate | dateFormat}} ({{timezoneEnv}})</p>
        <a :href="schedule" target="_parent" class="btn btn-lg btn-primary" v-if="isPrimary">Ready to Schedule</a>
      </div>
    </div>`
})
const StatusToolTipPending = Vue.component('StatusToolTipPending', {
  mixins: [iframeParentCommunication],
  data () {
    return {
      data: {},
      hasEmailContentApproval: {}
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.manageCampaigns.campaign.summaryDetails
    })
  },
  mounted () {
    this.hasEmailContentApproval = this.$store.getters.getHasEmailContentApproval
  },
  methods: {
    approve () {
      this.$store.dispatch('approveCampaign', { projectId: this.campaign.projectId, userEmail: atob(this.$route.query.userEmail), showLoading: false })
        .then(response => {
          if (response.data.status === 200) {
            this.$parent.$parent.$parent.refreshCampaigns()
          } else {
            console.log('error approving campaign')
            this.$refs.errorToastRef.show()
          }
        }, error => {
          console.log('error approving campaign', error)
          this.$refs.errorToastRef.show()
        })
    },
    reject () {
      this.$parent.$parent.$parent.openRejectDialog()
    },
    openApprovalDashboard () {
      const data = {
        action: 'eIn_approval_dashboard',
        value: {
          projectId: this.$route.query.campaignId,
          companyId: this.$route.query.companyId
        }
      }
      this.SendMessageToParent(data)
    }
  },
  template: `
    <div>
      <p class="tooltip-title">Approval requested by {{campaign.approvalRequestedBy}}</p>
      <p class="text-muted">{{campaign.approvalRequestedDate | dateFormat}}</p>
      <p><a v-if="hasEmailContentApproval.settingValue==='Y'" href="javascript:void(0)" @click="openApprovalDashboard">Approval Dashboard</a></p>
      <div v-if="campaign.canApproveCampaign">
        <a href="javascript:void(0)" @click="approve" class="btn btn-success btn-lg">Approve</a> 
        <a href="javascript:void(0)" @click="reject" class="btn btn-danger btn-lg">Reject</a>
      </div>
    </div>`
})
const StatusToolTipTesting = Vue.component('StatusToolTipTesting', {
  mixins: [iframeParentCommunication],
  data () {
    return {
      hasEmailContentApproval: {}
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.manageCampaigns.campaign.summaryDetails
    })
  },
  mounted () {
    this.hasEmailContentApproval = this.$store.getters.getHasEmailContentApproval
  },
  methods: {
    requestApproval () {
      const parentCompanyId = this.$route.query.clientId
      const projectId = this.campaign.projectId
      const userEmail = atob(this.$route.query.userEmail)
      if (parentCompanyId && projectId) {
        if (this.hasEmailContentApproval.settingValue === 'Y') {
          const data = {
            action: 'eIn_send_for_approval',
            value: {
              projectId: projectId,
              companyId: this.$route.query.companyId
            }
          }
          this.SendMessageToParent(data)
        } else {
          this.$store.dispatch('requestApproval', { parentCompanyId, projectId, userEmail })
            .then(response => {
              if (response.data.status === 200) {
                this.$parent.$parent.$parent.refreshCampaigns()
              } else {
                console.log('error requesting approval')
                this.$parent.$parent.$parent.errorMessage = 'An error has ocurred requesting approval'
                this.$refs.errorToastRef.show()
              }
            }, error => {
              console.log('error requesting approval', error)
              this.$parent.$parent.$parent.errorMessage = 'An error has ocurred requesting approval'
              this.$refs.errorToastRef.show()
            })
        }
      }
    }
  },
  template: `
    <div>
      <button @click="requestApproval" class="tooltip-link btn btn-lg btn-primary">
        Request Approval
      </button>
    </div>`
})
const EditScheduleDialogTemplate = Vue.component('EditScheduleDialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeEditScheduleDialog()
    },
    editCampaign () {
      this.$parent.$parent.editScheduledCampaign()
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Confirm</h2></br>
         <p>This project has already been scheduled.<br />
          Saving any changes to the Audience or Template will delete the existing schedule.</p>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="editCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})
const LaunchCampaignDialogTemplate = Vue.component('LaunchCampaignDialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeLaunchCampaignDialog()
    },
    launchCampaignJourney () {
      this.$parent.$parent.launchCampaignJourney()
      this.$parent.$parent.closeLaunchCampaignDialog()
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Confirm</h2></br>
         <p>Your existing campaign schedule will be deleted if you launch a Campaign Journey.</p>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="launchCampaignJourney" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})
const RejectDialogTemplate = Vue.component('RejectDialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      },
      reason: ''
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeRejectDialog()
    },
    rejectCampaign () {
      this.$parent.$parent.rejectCampaign(this.reason)
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Reject Confirm</h2></br>
         <p>Are you sure you wish to reject this campaign?</p>
         <div class="form-group">
          <label for="textarea" class="col-form-label">Please explain:</label>
          <textarea class="form-control" id="textarea" v-model="reason"></textarea>
        </div>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="rejectCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})

export default {
  components: {
    Card,
    History,
    LoadingSpinner
  },
  mixins: [phraseStyles, iframeParentCommunication],
  data () {
    return {
      statusToolTip () {
        return {
          template: statusToolTip
        }
      },
      dialogTemplate () {
        return {
          template: dialogTemplate
        }
      },
      statusToolTipPending () {
        return {
          template: StatusToolTipPending
        }
      },
      statusToolTipTesting () {
        return {
          template: StatusToolTipTesting
        }
      },
      editScheduleDialogTemplate () {
        return {
          template: EditScheduleDialogTemplate
        }
      },
      launchCampaignDialogTemplate () {
        return {
          template: LaunchCampaignDialogTemplate
        }
      },
      rejectDialogTemplate () {
        return {
          template: RejectDialogTemplate
        }
      },
      newAudienceTemplate: newAudienceTemplate,
      converted: false,
      newAudienceName: '',
      target: '#app',
      eInsightUrl: eInsightUrl,
      height: '',
      width: '400px',
      animationSettings: { effect: 'Fade', duration: 100 },
      toastPosition: { X: 'Right', Y: 'Top' },
      errorMessage: '',
      noJourneyLaunchStatuses: ['Rejected', 'Pending', 'Testing', 'Draft', 'Scheduled Active', 'Scheduled Inactive']
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.manageCampaigns.campaign.summaryDetails,
      history: state => state.manageCampaigns.campaign.history.slice(0, 5),
      clientId: state => state.manageCampaigns.clientId,
      isTransactional: state => state.manageCampaigns.isTransactional,
      isPrimary: state => state.manageCampaigns.isPrimary,
      dynamicContentUrl: (state) => {
        const campaign = state.manageCampaigns.campaign.summaryDetails
        if (campaign.projectId && campaign.companyID) {
          let dynamicContentUrl = window.App.$store.getters.getEinsightUri + process.env.VUE_APP_DYNAMIC_CONTENT_URL
          dynamicContentUrl = dynamicContentUrl.replace('{projectId}', campaign.projectId)
          dynamicContentUrl = dynamicContentUrl.replace('{companyId}', campaign.companyID)
          return dynamicContentUrl
        }
        return null
      }
    }),
    ...mapGetters({
      loadingStatus: 'getLoadingStatus',
      campaignJourney: 'getCampaignJourney',
      hasEmailContentApproval: 'getHasEmailContentApproval',
      audienceSummary: 'getAudienceSummary'
    }),
    scheduleActiveColor: function () {
      let scheduleActiveColor = 'unset'
      switch (this.campaign.scheduleActive) {
        case 'Active':
          scheduleActiveColor = 'success'
          break
        case 'Inactive':
          scheduleActiveColor = 'danger'
          break
        default:
          break
      }
      return scheduleActiveColor
    },
    viewProject () {
      return this.$store.getters.getEinsightUri + eInsightUrl.view(this.$route.query.campaignId)
    },
    previewProject () {
      return this.$store.getters.getEinsightUri + eInsightUrl.preview(this.$route.query.campaignId)
    }
  },
  mounted () {
    const campaignId = this.$route.query.campaignId
    const email = atob(this.$route.query.userEmail)
    if (campaignId) {
      this.$store.dispatch('setCampaignSummary', { projectId: campaignId, userEmail: email })
      this.$store.dispatch('setCampaignHistory', { projectId: campaignId, userEmail: email })
      this.$store.dispatch('setCompanySetting', { settings: 'HasEmailContentApproval', email: email })
    }
    if (!this.campaignJourney.settingValue && this.$route.query.userEmail) {
      this.$store.dispatch('setParentCompanySetting', { settings: 'Campaign Journey', email: email })
    }
    const parentCompanyId = this.$route.query.clientId
    this.$store.dispatch('setCampaignAudienceSummary', { parentCompanyId, projectId: campaignId, userEmail: email })
  },
  methods: {
    closeTooltipButton () {
      this.$refs.newAudienceTooltip.close()
    },
    onCustomOpen (args) {
      if (args.target.getAttribute('data-tooltip-id')) {
        this.$refs.tooltip.close()
      } else {
        this.$refs.tooltip.open(args.target)
      }
    },
    closeTooltip () {
      if (this.$refs.tooltip) {
        this.$refs.tooltip.close()
      }
    },
    convertToAudience (audienceName) {
      const projectId = this.$route.query.campaignId
      const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : null
      this.$store.dispatch('setCampaignConvertToAudience', { projectId, audienceName, userEmail })
        .then(response => {
          console.log('CampaignDetailSummary setCampaignConvertToAudience: ', response.data.status)
          console.log('CampaignDetailSummary setCampaignConvertToAudience: ', response)
          if (response.data.status === 200) {
            this.$store.commit('UPDATE_CAMPAIGNS_AUDIENCE', { response: response.data, projectId })
            this.refreshCampaigns()
          } else {
            console.log('error converting')
            this.$parent.$parent.errorMessage = 'An error has ocurred converting to audience'
            this.$refs.errorToastRef.show()
          }
        }, error => {
          console.log('error converting', error)
          this.$parent.$parent.errorMessage = 'An error has ocurred converting to audience'
          this.$refs.errorToastRef.show()
        })
    },
    openDialog () {
      this.$refs.dialogTemplate.show()
    },
    closeDialog () {
      this.$refs.dialogTemplate.hide()
    },
    openEditScheduleDialog () {
      this.$refs.editScheduleDialogTemplate.show()
    },
    closeEditScheduleDialog () {
      this.$refs.editScheduleDialogTemplate.hide()
    },
    openLaunchCampaignDialog () {
      if (this.campaign.statusCampaignTranslated === 'Approved') {
        this.launchCampaignJourney()
      } else {
        this.$refs.launchCampaignDialogTemplate.show()
      }
    },
    closeLaunchCampaignDialog () {
      this.$refs.launchCampaignDialogTemplate.hide()
    },
    launchCampaignJourney () {
      const data = {
        action: 'eIn_launch_campaign_journey',
        value: {
          clientId: this.$route.query.clientId,
          companyId: this.$route.query.companyId,
          projectId: this.$route.query.campaignId,
          journeyId: this.campaign.campaignJourneyInfo.length ? this.campaign.campaignJourneyInfo.primaryId : null
        }
      }
      this.SendMessageToParent(data)
    },
    openRejectDialog () {
      this.$refs.rejectDialogTemplate.show()
    },
    closeRejectDialog () {
      this.$refs.rejectDialogTemplate.hide()
    },
    editScheduledCampaign () {
      const uri = '/Project.mvc/Project/EditSchedule?projectId=' + this.campaign.projectId + '#schedule'
      const data = { action: 'eIn_redirect', value: uri }
      this.SendMessageToParent(data)
      this.$refs.editScheduleDialogTemplate.hide()
    },
    rejectCampaign (reason) {
      this.$store.dispatch('rejectCampaign', { projectId: this.campaign.projectId, reason: reason, userEmail: atob(this.$route.query.userEmail) })
        .then(response => {
          if (response.data.status === 200) {
            this.refreshCampaigns()
          } else {
            console.log('error reject campaign')
            this.$refs.errorToastRef.show()
          }
          this.closeRejectDialog()
        }, error => {
          console.log('error reject campaign', error)
          this.$refs.errorToastRef.show()
          this.closeRejectDialog()
        })
    },
    overlayClick: function () {
      this.$refs.dialogTemplate.hide()
      this.$refs.editScheduleDialogTemplate.hide()
      this.$refs.rejectDialogTemplate.hide()
    },
    deactivateSchedule () {
      const data = {
        action: 'eIn_cancel_schedule',
        value: {
          url: this.$store.getters.getEinsightUri + this.eInsightUrl.cancelSchedule(this.$route.query.campaignId)
        }
      }
      this.SendMessageToParent(data)
    },
    openEmailTypeSettings () {
      const data = {
        action: 'eIn_email_type',
        value: {
          companyId: this.$route.query.companyId,
          emailTypeId: this.campaign.emailTypeId
        }
      }
      this.SendMessageToParent(data)
    },
    refreshCampaigns () {
      const companyId = this.$route.query.companyId
      const isPrimary = this.isPrimary
      const projectId = this.$route.query.campaignId
      const userEmail = atob(this.$route.query.userEmail)
      const showLoading = false
      if (projectId) {
        this.$store.dispatch('setCampaignsByPage', { companyId, isPrimary, userEmail, showLoading })
        this.$store.dispatch('setCampaignSummary', { projectId, userEmail, showLoading })
        this.$store.dispatch('setCampaignHistory', { projectId, userEmail, showLoading })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .e-control {
    font-size: 1.6rem;
    font-family: 'Source Sans Pro';
  }
  .link {
    color: $secondary;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
  #dialog {
    max-height: none !important;
  }
  .custom-tooltip:hover {
    cursor: pointer;
  }
  .noJourneyLaunch {
    height: 125px;
  }
</style>
